import { render, staticRenderFns } from "./emailConfigDetail.vue?vue&type=template&id=14b73d54&scoped=true"
import script from "./emailConfigDetail.vue?vue&type=script&lang=js"
export * from "./emailConfigDetail.vue?vue&type=script&lang=js"
import style0 from "./emailConfigDetail.vue?vue&type=style&index=0&id=14b73d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b73d54",
  null
  
)

export default component.exports